import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M14 14v1.17L17.17 12 14 8.83V10H6v4z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 12l-8-8v4H4v8h8v4l8-8zM6 14v-4h8V8.83L17.17 12 14 15.17V14H6z"
})), 'ForwardTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ForwardTwoTone.js
// module id = 3938
// module chunks = 2